import React, {Component} from 'react';
import './App.css';
import {
    DownloadPage,
    RemotePage,
    RemoteWebPage,
    DashboardPage,
    SNSLogin,
} from './pages';
import { Route, Switch, useLocation } from 'react-router-dom';

const App = () => {

    const query = new URLSearchParams(useLocation().search);
    const command = query.get("command");
    const param = query.get("param");

    console.log('command', command, 'param', param);

    switch(command) {
        case 'download':
            return <DownloadPage/>;
        case 'remote':
            return <RemotePage/>;
        case 'web':
            return <RemoteWebPage/>;
        case 'dashboard':
            return <DashboardPage/>;
        case 'oauth':
            return <SNSLogin success={param}/>;
        default:
            return <div>Not found</div>
    }

};
export default App;
